import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListaPageComponent } from './lista-page/lista-page.component';
import { DettaglioPageComponent } from './dettaglio-page/dettaglio-page.component';

const istatComuniRoutes: Routes = [
  {
    path: 'lista',
    component: ListaPageComponent,
    children: [],
  },
  {
    path: ':id',
    component: DettaglioPageComponent,
    children: [],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(istatComuniRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class IstatComuniRoutingModule { }
